import addedVouchers from './addedVouchers'
import agent from './agent'
import apiError from './apiError'
import clientTypeTab from './clientTypeTab'
import company from './company'
import coupons from './coupons'
import deliveryDetails from './deliveryDetails'
import digiData from './digiData/digiData'
import payment from './payment'
import reservation from './reservation'
import serialTickets from './serialTickets'
import sso from './sso'
import summary from './summary'
import user from './user'

export default {
  addedVouchers,
  agent,
  apiError,
  company,
  clientTypeTab,
  deliveryDetails,
  digiData,
  payment,
  reservation,
  serialTickets,
  sso,
  summary,
  user,
  coupons
}
